import { render } from "./FooterSocial.vue?vue&type=template&id=ea1e2568&scoped=true"
import script from "./FooterSocial.vue?vue&type=script&lang=js"
export * from "./FooterSocial.vue?vue&type=script&lang=js"

import "./FooterSocial.vue?vue&type=style&index=0&id=ea1e2568&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea1e2568"]])

export default __exports__